import {
    _showClearIcon,
    _dropSingleCommonHtml,
    _getLabelByValue,
    _dropCommonHtml, _hideClearIcon
} from "./Common_Fun";

import {AssertUtils,GoingUtils} from "goingutils";
import EditorTypeUtils from "../../../common/editorTypeUtils";
import dropCodingFactory from "../../../common/dropCodingFactory";

function ___getDisplay({search}) {
    if (search) {
        return "block";
    } else {
        return "none";
    }
}

function _getSelRelVal(textVal, itemObj) {
    let labelShow = textVal;
    for (let nums = 0; nums < itemObj.items.length; nums++) {
        let {id, label} = itemObj.items[nums];
        if (textVal === id) {
            labelShow = label;
            break;
        }
    }
    return labelShow;
}

//获取子项集合
function _getSonItems(items, options, itemObj) {
    let sonHtmls = [];
    //如果items为空  options为空则通过url 来构建下拉
    if (!AssertUtils.isNotNull(items) && !AssertUtils.isNotNull(options)) {
        let {url} = itemObj;
        dropCodingFactory.getCodingAry(url, (backAry) => {
            //重写item的label值
            backAry.forEach(function (item) {
                item["label"] = item["name"];
                item["id"] = item["value"];
            });
            backAry.forEach(function ({value, label, text, id}) {
                sonHtmls.push(
                    `<div class="go-drop-item static-item" value="${value ||
                    id}" label="${label || text}">${label || text}</div>`
                );
            });
        });
    } else {
        if (items == null) {
            items = options;
        }
        //如果items不为空 而且是数组 才需要这么操作
        if (AssertUtils.isNotNull(items) && AssertUtils.isArray(items)) {
            if (items != null) {
                items.forEach(function ({value, label, text, id}) {
                    sonHtmls.push(
                        `<div class="go-drop-item static-item" value="${value ||
                        id}" label="${label || text}">${label || text}</div>`
                    );
                });
            }
        }
    }
    return sonHtmls.join("");
}

let StaticDropCtl = {
    /**
     * 获取控件的html
     * @param formType 表单类型 分查询表单 和普通表单
     * @param item 选项
     * @param targetObj 可能是GoingForm对象 也可能是QueryForm对象
     */
    getHtml: function (formType, item, targetObj) {
        if (formType === "singleQuery") {
            return this.getSingleQueryHtml(item, targetObj);
        } else {
            return this.getEditorHtml(item, targetObj);
        }
    },
    //获取显示值
    getShowValue(curVal, item) {
        //循环子项 根据值获取label的显示值
        for (let num = 0; num < item.items.length; num++) {
            let itemObj = item.items[num];
            if (itemObj["id"] === curVal) {
                return itemObj["label"];
            }
        }
        return curVal || " ";
    },
    /**
     * 获取编辑模式下的html代码
     * @param item
     * @param targetObj
     * @returns {string}
     */
    getSingleQueryHtml: function (item, targetObj) {
        return _dropSingleCommonHtml(
            item,
            targetObj,
            "go-ctl-static-drop",
            "ivu-icon ivu-icon-ios-arrow-down"
        );
    },
    getEditorHtml: function (item, targetObj) {
        return _dropCommonHtml(
            item,
            targetObj,
            "go-ctl-static-drop",
            "ivu-icon ivu-icon-ios-arrow-down"
        );
    },
    /**
     * 初始化提交数据
     * @param item
     * @param targetObj 目标form对象
     * @param backJson 返回的数据
     * @param formType 表单类型
     */
    getSubmitData: function (
        item,
        targetObj,
        backJson,
        formType
    ) {
        if (formType === "query") {
            this.getQuerySubmitData(item, targetObj, backJson);
        } else {
            this.getEditorSubmitData(item, targetObj, backJson);
        }
    },
    getQuerySubmitData: function (item, targetObj, backJson) {
        this.getEditorSubmitData(item, targetObj, backJson);
    },
    getEditorSubmitData: function (item, targetObj, backJson) {
        //如果关联id 不为空则返回关联id 的值
        if (AssertUtils.isNotEmpty(item["treeRelId"])) {
            //如果编数据下拉
            backJson[item["treeRelId"]] = $(
                `#${targetObj.prefixCls}_${item["treeRelId"]}`
            ).val();
        }
        if ($(`#${targetObj.prefixCls}_${item["id"]}`).val() === '') {
            backJson[item["id"]] = "";
        }else{
            backJson[item["id"]] = $(
                `#${targetObj.prefixCls}_${item["id"]}_val`
            ).val();
        }
    },
    setValue(prop, propValue, item, targetObj) {
        //获取输入框的id
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        //如果选择是通过label 则不需要进行映射关系的处理
        if (item.selByText) {
            $("#" + inputElId).val(propValue);
            $("#" + inputElId + "_val").val(propValue);
        } else {
            let label = _getLabelByValue(propValue, item.items);
            //如果是通过value来选择值
            if (AssertUtils.isNotEmpty(label)) {
                $("#" + inputElId).val(label);
                $("#" + inputElId + "_val").val(propValue);
            }
        }
    },
    getRealValue(value) {
        return value || " ";
    },
    clearData(item, formType, targetObj) {
        //如果关联id 不为空则返回关联id 的值
        if (AssertUtils.isNotEmpty(item["treeRelId"])) {
            //如果编数据下拉
            $(`#${targetObj.prefixCls}_${item["treeRelId"]}`).val("");
        }
        $(`#${targetObj.prefixCls}_${item["id"]}_val`).val("");
        $(`#${targetObj.prefixCls}_${item["id"]}`).val("");
    },
    getDropContainerHtml(inputId, inputWidth, itemObj) {
        let zIndex = GoingUtils.getCurMaxZIndex()+100;
        inputWidth = inputWidth + "px";
        let html = `<div style="position: absolute; top: 0;z-index: ${parseFloat(zIndex + "") + 1}; left: 0; width: 100%;">
                            <div>
                                <div  id="${inputId}_static_drop"  class="go-common-drop " style="max-height: 400px;padding-bottom: 8px; overflow: auto; width: ${inputWidth};">
                                    <div class="search-bar" style="display: ${___getDisplay(itemObj)}">
                                    <div class="input-icon right" style="border-radius: 0px;"><i class="fas fa-search"></i>
                                    <input id="${inputId}_search"  type="text" placeholder="输入筛选" class="form-control">
                                    </div></div> 
                                    <div  class="search-body">
                                         ${_getSonItems(itemObj["items"],itemObj["options"],itemObj)}
                                    </div>
                                </div>
                            </div>
                        </div>`;
        return html;
    },
    initDefaultEvent(inputId, itemObj, targetObj, vueObj) {
        //点击输入框 弹出下拉选择数据
        $(`#${inputId}`).click(function () {
            let {x, y} = GoingUtils.getElementPosition($(this).get(0));
            //设置显示的下拉位置
            $(`#${inputId}_static_drop`)
                .show()
                .css("left", x)
                .css(
                    "top",
                    y +
                    2 +
                    parseFloat(
                        $(this)
                            .closest(".input-group")
                            .css("height")
                    )
                );
        });

        //选择下拉子项信息 填写数据
        $(`#${inputId}_static_drop .static-item`).click(function () {
            $(`#${inputId}`).val($(this).attr("label") + "");
            //执行change的回调函数
            let elId = inputId.replaceAll(targetObj.prefixCls + "_", "");
            if (vueObj != null) {
                vueObj.$emit("change", {
                    value: $(this).attr("value"),
                    id: elId,
                    elObj: $(`#${inputId}`)
                });
            }

            if (AssertUtils.isNotNull(itemObj["treeRelId"])) {
                $(`#${targetObj.prefixCls}_${itemObj["treeRelId"]}`).val(
                    $(this).attr("value") + ""
                );
            } else {
                $(`#${inputId}_val`).val($(this).attr("value") + "");
            }
            $(`#${inputId}_static_drop`).hide();
        });

        //如果点击的不是控件本身 则隐藏
        $(document).click(function (e) {
            let target = $(e.target);
            if (
                !target.is("#" + inputId + " *") &&
                !target.is("#" + inputId) &&
                !target.is(`#${inputId}_static_drop *`) &&
                !target.is(`.dhxtreeview_icon`)
            ) {
                $(`#${inputId}_static_drop`).hide();
            }
        });
    },
    initCtlEvent: function (
        parentObj,
        inputWidth,
        targetObj,
        vueObj
    ) {
        $(parentObj).find(".go-ctl-static-drop")
            .each(function (index,itemObjEl) {
                let inputId = $(this).attr("id");
                //获取当前定义的字段属性
                let itemObj = (EditorTypeUtils.itemTemp)[inputId];
                //如果是从switch转过来的 则需要初始化其中的items
                if ("switch" === itemObj.type) {
                    itemObj["items"] = [
                        {label: "启用", value: "true"},
                        {label: "停用", value: "false"}
                    ];
                }
                //如果下拉默认值不为空 而且selByText不为true 则需要进行默认值的翻译
                if (AssertUtils.isNotEmpty($("#" + inputId).val()) && itemObj["selByText"] !== true) {
                    $("#" + inputId).val(_getSelRelVal($("#" + inputId).val(), itemObj));
                }
                //如果声明了
                if ($(this).attr("ctl") === "auto") {
                    //将内容添加到界面上
                    $(StaticDropCtl.getDropContainerHtml(inputId, inputWidth, itemObj)).appendTo($("#main_router_view"));
                    //初始化下拉的相关事件
                    StaticDropCtl.initDefaultEvent(inputId, itemObj, targetObj, vueObj);
                }

                //显示 隐藏清空图标
                $(itemObjEl).mouseover(function () {
                    let elVal = $(`#${inputId}`).val();
                    if(AssertUtils.isNotEmpty(elVal)){
                        _showClearIcon(inputId,parentObj);
                    }
                }).mouseleave(function () {
                    _hideClearIcon(inputId);
                });
            });
    }
};

export default StaticDropCtl;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/js-drop.js